import { render, staticRenderFns } from "./AddAcount.vue?vue&type=template&id=98d397cc&scoped=true"
import script from "./AddAcount.vue?vue&type=script&lang=js"
export * from "./AddAcount.vue?vue&type=script&lang=js"
import style0 from "./AddAcount.vue?vue&type=style&index=0&id=98d397cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d397cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98d397cc')) {
      api.createRecord('98d397cc', component.options)
    } else {
      api.reload('98d397cc', component.options)
    }
    module.hot.accept("./AddAcount.vue?vue&type=template&id=98d397cc&scoped=true", function () {
      api.rerender('98d397cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/merchantAccount/detail-pane/AddAcount.vue"
export default component.exports